class RecentlyViewed extends HTMLElement {
    connectedCallback() {
       requestAnimationFrame(() => {
          this.container = this.querySelector(".recently-viewed-grid");

          console.log("Container:", this.container);

          if (!this.container) {
            console.warn("Container not found inside recently-viewed");
            return;
          }

          this.RecentlyViewedData = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
          this.currentHandle = window.location.pathname;

          this.loadProductData();
        });
    }
    loadProductData() {
        if (!this.RecentlyViewedData || !this.RecentlyViewedData.length) return;
        this.RecentlyViewedData.forEach((handle) => {
            if(this.currentHandle.includes(handle)) return;

            fetch(`/products/${handle}?sections=product-grid`)
            .then(response => response.json())
            .then(data => {
                const htmlString = data['product-grid'];
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, "text/html");
                const productCard = doc.querySelector("product-card");
                if (productCard) {
                  
                this.container.innerHTML += productCard.outerHTML;
                }
            });
        });
    }
}

customElements.define('recently-viewed', RecentlyViewed);